<div *ngIf="votacaoAberta == 1">
  <app-login></app-login>
</div>

<div *ngIf="votacaoAberta == 2">
  <app-sessao-nao-aberta></app-sessao-nao-aberta>
</div>

<!--
<div *ngIf="votacaoAberta == 0">
 <app-falha-conexao-servidor></app-falha-conexao-servidor>
</div>
-->



